import { __makeTemplateObject } from "tslib";
import styled, { css } from 'styled-components';

var getSize = function getSize(size) {
  switch (size) {
    case 'regular':
      {
        return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        width: 40px;\n        height: 40px;\n      "], ["\n        width: 40px;\n        height: 40px;\n      "])));
      }

    case 'compact':
    default:
      {
        return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n        width: 32px;\n        height: 32px;\n      "], ["\n        width: 32px;\n        height: 32px;\n      "])));
      }
  }
};

var getColor = function getColor(color) {
  switch (color) {
    case 'primary':
      {
        return css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n        color: ", ";\n\n        &:hover {\n          color: ", ";\n          background-color: ", ";\n        }\n\n        &:active {\n          color: ", ";\n          background-color: ", ";\n        }\n      "], ["\n        color: ", ";\n\n        &:hover {\n          color: ", ";\n          background-color: ", ";\n        }\n\n        &:active {\n          color: ", ";\n          background-color: ", ";\n        }\n      "])), function (_a) {
          var theme = _a.theme;
          return theme.palette.label.secondary;
        }, function (_a) {
          var theme = _a.theme;
          return theme.palette.label.secondaryHigh;
        }, function (_a) {
          var theme = _a.theme;
          return theme.palette.fill.primary.overlay16;
        }, function (_a) {
          var theme = _a.theme;
          return theme.palette.label.primary;
        }, function (_a) {
          var theme = _a.theme;
          return theme.palette.fill.primary.overlay32;
        });
      }

    case 'static':
      {
        return css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n        color: ", ";\n\n        &:hover {\n          color: ", ";\n          background-color: ", ";\n        }\n\n        &:active {\n          color: ", ";\n          background-color: ", ";\n        }\n      "], ["\n        color: ", ";\n\n        &:hover {\n          color: ", ";\n          background-color: ", ";\n        }\n\n        &:active {\n          color: ", ";\n          background-color: ", ";\n        }\n      "])), function (_a) {
          var theme = _a.theme;
          return theme.palette.static.whiteAlfa56;
        }, function (_a) {
          var theme = _a.theme;
          return theme.palette.static.whiteAlfa72;
        }, function (_a) {
          var theme = _a.theme;
          return theme.palette.static.whiteAlfa4;
        }, function (_a) {
          var theme = _a.theme;
          return theme.palette.static.white;
        }, function (_a) {
          var theme = _a.theme;
          return theme.palette.static.whiteAlfa8;
        });
      }

    case 'secondary':
    default:
      {
        return css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n        color: ", ";\n\n        &:hover {\n          color: ", ";\n          background-color: ", ";\n        }\n\n        &:active {\n          color: ", ";\n          background-color: ", ";\n        }\n      "], ["\n        color: ", ";\n\n        &:hover {\n          color: ", ";\n          background-color: ", ";\n        }\n\n        &:active {\n          color: ", ";\n          background-color: ", ";\n        }\n      "])), function (_a) {
          var theme = _a.theme;
          return theme.palette.label.secondary;
        }, function (_a) {
          var theme = _a.theme;
          return theme.palette.label.secondaryHigh;
        }, function (_a) {
          var theme = _a.theme;
          return theme.palette.fill.secondary.overlay16;
        }, function (_a) {
          var theme = _a.theme;
          return theme.palette.label.primary;
        }, function (_a) {
          var theme = _a.theme;
          return theme.palette.fill.secondary.overlay32;
        });
      }
  }
};

export var Root = styled.button.withConfig({
  displayName: "ui-kit-Root",
  componentId: "ui-kit-1dybyb0"
})(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  padding: 0;\n  margin: 0;\n  position: relative;\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  border: 0;\n  cursor: pointer;\n  outline: none;\n  user-select: none;\n  text-decoration: none;\n  text-align: center;\n  background-color: transparent;\n  border-radius: 50%;\n  transition: background-color 150ms cubic-bezier(0.4, 0, 0.2, 1), color 150ms;\n\n  ", "\n  ", "\n\n  & > svg {\n    color: inherit;\n  }\n\n  &:before {\n    content: '';\n    width: 100%;\n    height: 100%;\n    display: block;\n    position: absolute;\n    border-radius: 50%;\n    background-color: currentColor;\n    opacity: 0;\n    transform: scale(1);\n    transition: transform 0.5s, opacity 0.5s;\n    will-change: transform, opacity;\n    pointer-events: none;\n  }\n\n  &:active {\n    &:before {\n      opacity: 0.32;\n      transform: scale(0);\n      transition: 0s;\n    }\n  }\n\n  &:focus-visible {\n    box-shadow: inset 0px 0px 0px 3px ", ";\n  }\n\n  &:disabled,\n  &[disabled] {\n    cursor: default;\n    color: ", ";\n    background-color: transparent;\n    box-shadow: none;\n    pointer-events: none;\n\n    &:before {\n      content: none;\n    }\n  }\n"], ["\n  padding: 0;\n  margin: 0;\n  position: relative;\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  border: 0;\n  cursor: pointer;\n  outline: none;\n  user-select: none;\n  text-decoration: none;\n  text-align: center;\n  background-color: transparent;\n  border-radius: 50%;\n  transition: background-color 150ms cubic-bezier(0.4, 0, 0.2, 1), color 150ms;\n\n  ", "\n  ", "\n\n  & > svg {\n    color: inherit;\n  }\n\n  &:before {\n    content: '';\n    width: 100%;\n    height: 100%;\n    display: block;\n    position: absolute;\n    border-radius: 50%;\n    background-color: currentColor;\n    opacity: 0;\n    transform: scale(1);\n    transition: transform 0.5s, opacity 0.5s;\n    will-change: transform, opacity;\n    pointer-events: none;\n  }\n\n  &:active {\n    &:before {\n      opacity: 0.32;\n      transform: scale(0);\n      transition: 0s;\n    }\n  }\n\n  &:focus-visible {\n    box-shadow: inset 0px 0px 0px 3px ", ";\n  }\n\n  &:disabled,\n  &[disabled] {\n    cursor: default;\n    color: ", ";\n    background-color: transparent;\n    box-shadow: none;\n    pointer-events: none;\n\n    &:before {\n      content: none;\n    }\n  }\n"])), function (_a) {
  var size = _a.size;
  return getSize(size);
}, function (_a) {
  var color = _a.color;
  return getColor(color);
}, function (_a) {
  var theme = _a.theme;
  return theme.palette.fill.primary.overlay24;
}, function (_a) {
  var theme = _a.theme;
  return theme.palette.label.inactive;
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;